import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { configuration } from 'src/environments/environment';
import { IDocLibPatientForms, IPatientForms } from 'src/app/models/IPatientForms';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { IPatientPersonalInfo } from 'src/app/models/IPatientPersonalInfo';

@Injectable({
  providedIn: 'root'
})
export class PatientformService {

  constructor(private http: HttpClient) { }

  savePatientFormInfo(patientFormInfo: IPatientForms): Observable<IPatientForms> {
    return this.http.post<IPatientForms>(`${configuration.apiUrl + 'Patient/PatientForm'}`, patientFormInfo, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPatientFormInfo(patientId: number, showAll: boolean, userId = sessionStorage.getItem("userId")): Observable<IPatientForms[]> {
    return this.http.get<IPatientForms[]>(`${configuration.apiUrl + 'Patient/GetPatientForm'}?patientId=${patientId}&&userId=${userId}&&showAll=${showAll}`);
  }

  getPatientFormInfoDocLib(patientId: number, TargetLocID: number, showAll: boolean, userId = sessionStorage.getItem("userId")): Observable<IPatientForms[]> {
    const postedData = {
      patientId: patientId,
      TargetLocID: TargetLocID,
      LocationID: sessionStorage.getItem("LocationId"),
      userId: userId,
      showAll: showAll
    }
    return this.http.post<IPatientForms[]>(`${configuration.apiUrl + 'Patient/GetPatientFormDocLib'}`, postedData);

    // return this.http.get<IPatientForms[]>(`${configuration.apiUrl + 'Patient/GetPatientFormDocLib'}?patientId=${patientId}&&TargetLocID=${TargetLocID}&&LocationID=${sessionStorage.getItem("LocationId")}&&userId=${userId}&&showAll=${showAll}`);
  }

  getPatientFormInfoDocLibAll(patientId: number, TargetLocID: number, showAll: boolean, userId = sessionStorage.getItem("userId")): Observable<IPatientForms[]> {
    const postedData = {
      patientId: patientId,
      TargetLocID: TargetLocID,
      LocationID: sessionStorage.getItem("LocationId"),
      userId: userId,
      showAll: showAll
    }
    return this.http.post<IPatientForms[]>(`${configuration.apiUrl + 'Patient/GetPatientFormDocLib'}`, postedData);
    // return this.http.get<IPatientForms[]>(`${configuration.apiUrl + 'Patient/GetPatientFormDocLib'}?patientId=${patientId}&&TargetLocID=${TargetLocID}&&LocationID=${sessionStorage.getItem("LocationId")}&&userId=${userId}&&showAll=${showAll}`);
  }

  UpdateStatus(Id: number, userId = sessionStorage.getItem("userId")): Observable<number> {
    return this.http.post<number>(`${configuration.apiUrl + 'Patient/PatientForm'}?formid=${Id}&&userId=${userId}`, {
      //headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPatientGenderInfo(patientId: number, userId = sessionStorage.getItem("userId")): Observable<String> {
    return this.http.get<String>(`${configuration.apiUrl + 'Patient/GENDER'}?patientId=${patientId}&&userId=${userId}`);
  }

  updatePatientNoteHeightSetting(type: number, Changevalue: number): Observable<Boolean> {
    const request = { PatientId: encodeURIComponent(sessionStorage.getItem("patientId")).toString(), MType: type, Changevalue: Changevalue };
    return this.http.post<Boolean>(`${configuration.apiUrl + 'Patient/UpdatePateintNotesHeight'}`, request, { headers: new HttpHeaders({ 'content-Type': 'application/json' }) });
  }

  getPatientPersonalInfo(id: number): Observable<IPatientPersonalInfo> {
    return this.http.get<IPatientPersonalInfo>(
      `${configuration.apiUrl + 'Patient/PatientPersonalDetails'}?patientid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getPersonalInfo(id: number): Observable<IPersonalInfo> {
    const Personal_PenRequest = {
      patientid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      clientid: sessionStorage.getItem("FacilityId"),
      portal: null
    }
    return this.http.post<IPersonalInfo>(
      `${configuration.apiUrl + 'Patient/getPersonal'}`, Personal_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPatientFormInfoById(patientFormId: number, userId = sessionStorage.getItem("userId")): Observable<IPatientForms> {
    return this.http.get<IPatientForms>(`${configuration.apiUrl + 'Patient/PatientFormById'}?userId=${userId}&&formId=${patientFormId}`);
  }

  deleteFormDetails(formId: number): any {
    return this.http.post<any>(`${configuration.apiUrl + 'Patient/DeletePatientForm'}?patientFormId=${formId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  DocLibgetPatientFormInfoById(patientFormId: number, userId = sessionStorage.getItem("userId")): Observable<IPatientForms> {
    return this.http.get<IPatientForms>(`${configuration.apiUrl + 'Patient/PatientFormById'}?userId=${userId}&&formId=${patientFormId}`);
  }

  DocLibgetPatientPersonalInfo(id: number): Observable<IPatientPersonalInfo> {
    return this.http.get<IPatientPersonalInfo>(`${configuration.apiUrl + 'Patient/PatientPersonalDetails'}?patientid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  //EMR Patient CONSENT FORM 
  DocLibsavePatientFormInfo(patientFormInfo: IDocLibPatientForms, Isreset: boolean): Observable<string> {
    var appid = sessionStorage.getItem("appId") ? sessionStorage.getItem("appId").toString() : '';

    let _sigdata = patientFormInfo.Signature;
    patientFormInfo.Signature = null;
    const posteddata = {
      inputdata: JSON.stringify(patientFormInfo),
      sigdata: _sigdata,
      Appointmentid: appid
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/InsertEMRConsentDetails'}?Isreset=${Isreset}&&facilityId=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // DocLibsaveSignatureConsentForm(patientFormInfo: IDocLibPatientForms): Observable<string> {
  //   return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/InsertEMRConsentSignatures'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, patientFormInfo, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  DocLibdeleteFormDetails(formId: number): any {
    return this.http.post<any>(`${configuration.apiUrl + 'Patient/doclibDeletePatientForm'}?patientFormId=${formId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

}
